import { render, staticRenderFns } from "./short-messages-debug.vue?vue&type=template&id=7b9a9f9c&scoped=true"
import script from "./short-messages-debug.vue?vue&type=script&lang=js"
export * from "./short-messages-debug.vue?vue&type=script&lang=js"
import style0 from "./short-messages-debug.vue?vue&type=style&index=0&id=7b9a9f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9a9f9c",
  null
  
)

export default component.exports